export const BET_SLIP_DB_NAME = 'bs';
export const BET_SLIP_STORE_NAME = 'kv';
export const BET_SLIP_RECORD_ID = 'v1';

export const BET_SLIP_FORMAT = 'ES256' as const;
export type BetSlipFormat = typeof BET_SLIP_FORMAT;

export const BET_SLIP_READY_TIMEOUT_MS = 250;
export const BET_SLIP_TAG_TIMEOUT_MS = 50;

export const isBetSlipEnabled = (): boolean =>
  import.meta.env.VITE_BET_SLIP_ENABLED === 'true';
